import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { FormTitle, Text, SelectField,DatePickerField } from "ui-components/Form";

const options = {
  type: ["Carton", "Flyer"],
};

function BillingServiceInfo({ categoryOptions=[],criteriaOptions=[],formRender, control, errors, mode = "ADD" }) {
  return (
    <MDBox>
      <FormTitle title={mode === "EDIT" ? "Edit Billing Service" : "Billing Service Information"} />
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((property, index) => {
              const { editable, ...data } = property;
              const fieldProps = {
                ...data,
                control,
                errors,
                ...(mode === "EDIT" && editable === false && { disabled: true }),
              };

              let renderField;
              switch (fieldProps.type) {
                case "text":
                  renderField = <Text field={fieldProps} />;
                  break;
                case "date":
                  renderField = <DatePickerField field={fieldProps} />;
                  break;
                case "select":
                  let options = [];
                  // console.log("Rendering select field:", data.name);
                  // console.log("categoryOptions value:", categoryOptions);
                  // console.log("criteriaOptions value:", criteriaOptions);
                  switch (data.name) {
                    case "category":
                      options = categoryOptions
                      break;
                    case "criteria":
                      options = criteriaOptions
                      
                      break;
                  }
                //case "select":
                  renderField = <SelectField
                      field={fieldProps}
                      options={options}
                    />;
                    break;
              }

              return (
                <Grid item xs={12} key={index}>
                  {renderField}
                </Grid>
              );
            })}
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default BillingServiceInfo;
